export default [
  {
    path: 'operasional-keluar',
    redirect: { name: 'operationalouts' },
    component: { template: '<router-view />' },
    children: [
      {
        path: '/',
        name: 'operationalouts',
        component: () => import('@pages/operationalouts/Index.vue'),
        meta: {
          auth:true,
          pageTitle: 'Operasional Keluar',
          breadcrumb: [
            {
              text: 'Operasional',
            },
            {
              text: 'Operasional Keluar',
              active: true
            },
          ],
        }
      },
      {
        path: 'tambah',
        name: 'operationalouts-add',
        component: () => import('@pages/operationalouts/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Tambah Operasional Keluar',
          navActiveLink: 'operationalouts',
          quickName: 'Operasional Out',
          breadcrumb: [
            {
              text: 'Operasional',
            },
            {
              text: 'Operasional Keluar',
              to: { name: 'operationalouts' },
            },
            {
              text: 'Tambah',
              active: true
            },
          ],
        }
      },
      {
        path: ':id',
        name: 'operationalouts-edit',
        component: () => import('@pages/operationalouts/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Edit Operasional Keluar',
          navActiveLink: 'operationalouts',
          isEdit:true,
          breadcrumb: [
            {
              text: 'Operasional',
            },
            {
              text: 'Operasional Keluar',
              to: { name: 'operationalouts' },
            },
            {
              text: 'Edit',
              active: true
            },
          ],
        }
      },
      {
        path: ':id/persetujuan',
        name: 'operationalouts-approve',
        component: () => import('@pages/operationalouts/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Persetujuan Operasional Keluar',
          navActiveLink: 'operationalouts',
          isApprove:true,
          breadcrumb: [
            {
              text: 'Operasional',
            },
            {
              text: 'Operasional Keluar',
              to: { name: 'operationalouts' },
            },
            {
              text: 'Persetujuan',
              active: true
            },
          ],
        }
      }
    ]
  }
]